import { Entity, Cartesian2 } from "cesium";
import { useEffect, useRef } from "react";
import { useCesium } from "../Contexts/Widget3DContext";
export const Label = ({ label, positions, availability, }) => {
    const { isViewerLoaded, addEntity, removeEntity } = useCesium();
    const labelEntity = useRef(null);
    const addLabel = () => {
        const newLabelEntity = new Entity({
            id: `label ${label}`,
            name: `label ${label}`,
            availability,
            position: positions,
            label: {
                font: "12pt Lucida Console",
                pixelOffset: new Cartesian2(10, -10),
                text: label,
            },
        });
        return addEntity(newLabelEntity);
    };
    useEffect(() => {
        if (isViewerLoaded) {
            (labelEntity === null || labelEntity === void 0 ? void 0 : labelEntity.current) && removeEntity(labelEntity.current);
            labelEntity.current = addLabel();
        }
        return () => {
            (labelEntity === null || labelEntity === void 0 ? void 0 : labelEntity.current) && removeEntity(labelEntity.current);
        };
    }, [isViewerLoaded, label, positions, availability]);
    return null;
};
//# sourceMappingURL=Label.js.map